/**
 * Converts 1234.00432 to 1,234.00432
 *
 * @param numberString - The number string
 * @returns The number string with commas at every 3rd place
 */
export function addCommasToNumberString(numberString: string): string {
    const [beforeDot, afterDot] = numberString.split('.');
    const decimalPart = afterDot ? `.${afterDot}` : '';
    let numPart = beforeDot;
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(numPart)) {
        numPart = numPart.replace(rgx, '$1,$2');
    }
    return `${numPart}${decimalPart}`;
}
